export const API_BASE_URL = `${window.location.protocol}//${window.location.hostname}/ibs`;
// export const API_BASE_URL = "http://localhost:3010";// For Dev Env
// export const API_BASE_URL = "http://192.168.6.107:3010"; // For UAT ENV.
export const SOCKET_BASE_URL = "https://crm.fuzielevators.com/"; // Server Sub Domain
// export const SOCKET_BASE_URL = "http://103.175.163.63/"; //Server IP Addess
// export const SOCKET_BASE_URL = "http://192.168.6.107:3010"; // For Dev Env
// export const SOCKET_BASE_URL = "http://localhost:3010";//For UAT ENV.
// Only Create Permission Added By Farhan Khan on 23-oct-2023
// export const CREATE_ALL = "CREATE_ALL";

export const VIEW_LEAD = "VIEW_LEAD";
export const VIEW_PROPERTY = "VIEW_PROPERTY";
export const EDIT_LEAD = "EDIT_LEAD";
export const DELETE_LEAD = "DELETE_LEAD";
export const VIEW_PRODUCT = "VIEW_PRODUCT";
export const EDIT_PRODUCT = "EDIT_PRODUCT";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const MODIFY_ALL = "MODIFY_ALL";
export const VIEW_ALL = "VIEW_ALL";
export const VIEW_ORDER = "VIEW_ORDER";
export const VIEW_USER = "VIEW_USER";
export const VIEW_CONTACT = "VIEW_CONTACT";
export const EDIT_CONTACT = "EDIT_CONTACT";
export const DELETE_CONTACT = "DELETE_CONTACT";
export const VIEW_ACCOUNT = "VIEW_ACCOUNT";
export const EDIT_ACCOUNT = "EDIT_ACCOUNT";
export const DELETE_ACCOUNT = "DELETE_ACCOUNT";
export const VIEW_BUSINESS = "VIEW_BUSINESS";
export const EDIT_BUSINESS = "EDIT_BUSINESS";
export const DELETE_BUSINESS = "DELETE_BUSINESS";
export const VIEW_INCIDENT = "VIEW_INCIDENT";
export const CREATE_ALL = "CREATE_ALL";
export const SUPER_ADMIN = "SUPER_ADMIN";

//FILE TYPES
export const PDF = "pdf";
export const DOC = "doc";
export const DOCX = "docx";
export const XLS = "xls";
export const XLSX = "xlsx";
export const CSV = "csv";
export const PNG = "png";
export const JPG = "jpg";
export const JPEG = "jpeg";

// export const LEAD_STATUS_VALUES = [{label : 'Open - Not Contacted', islast : false}, {label : 'Working Contacted', islast : false} , {label : 'Closed - Converted', islast : true}, {label : 'Closed - Not Converted', islast : true}];
export const LEAD_STATUS_VALUES = [
  //Updated by Imran Khan on 29-12-2025 Lead Status with Colors AMC Ticket
  // 1
  {
    label: "Enquiry Pending",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
    css: { color: "black", backgroundColor: "#C7DCE3" }
  },

  // 2
  {
    label: "Enquiry Lost",
    sortorder: 2,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 3
  {
    label: "Site Visit Pending",
    sortorder: 3,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#8B4513" }
  },

  // 4
  {
    label: "Site Visit Complete",
    sortorder: 4,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#32CD32" }
  },

  // 5
  {
    label: "Site Visit Lost",
    sortorder: 5,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 6
  {
    label: "Offer Pending",
    sortorder: 6,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FFD700" }
  },

  // 7
  {
    label: "Offer Submitted",
    sortorder: 7,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FF9D23" }
  },

  // 8
  {
    label: "Offer Lost",
    sortorder: 8,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#7d0e04ff" }
  },

  // 9
  {
    label: "Order Received",
    sortorder: 9,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9ef49eff" }
  },

  // 10
  {
    label: "Order Lost",
    sortorder: 10,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#3833ceff" }
  },

  // 11
  {
    label: "Order Work in Progress",
    sortorder: 11,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#1E90FF" }
  },

  // 12
  {
    label: "Order Work Complete",
    sortorder: 12,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#eb0c61ff" }
  },

  // 13
  {
    label: "Warranty Running",
    sortorder: 13,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#7851A9" }
  },

  // 14
  {
    label: "Warranty Lost",
    sortorder: 14,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#476038ff" }
  },

  // 15
  {
    label: "AMC Running",
    sortorder: 15,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#008080" }
  },

  // 16
  {
    label: "AMC Lost",
    sortorder: 16,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#f71702ff" }
  },

  // 17
  {
    label: "AMC Direct Order",
    sortorder: 17,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#87e2deff" }
  },

  // 18
  {
    label: "One Time",
    sortorder: 18,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9b3131ff" }
  }
];
// Ended by Imran Khan on 29-12-2025 Lead Status with Colors AMC Ticket

export const OFFER_STATUS_VALUES = [
  //Updated by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket
  // 1
  {
    label: "Enquiry Pending",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
    css: { color: "black", backgroundColor: "#C7DCE3" }
  },

  // 2
  {
    label: "Enquiry Lost",
    sortorder: 2,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 3
  {
    label: "Site Visit Pending",
    sortorder: 3,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#8B4513" }
  },

  // 4
  {
    label: "Site Visit Complete",
    sortorder: 4,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#32CD32" }
  },

  // 5
  {
    label: "Site Visit Lost",
    sortorder: 5,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 6
  {
    label: "Offer Pending",
    sortorder: 6,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FFD700" }
  },

  // 7
  {
    label: "Offer Submitted",
    sortorder: 7,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FF9D23" }
  },

  // 8
  {
    label: "Offer Lost",
    sortorder: 8,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#7d0e04ff" }
  },

  // 9
  {
    label: "Order Received",
    sortorder: 9,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9ef49eff" }
  },

  // 10
  {
    label: "Order Lost",
    sortorder: 10,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#3833ceff" }
  },

  // 11
  {
    label: "Order Work in Progress",
    sortorder: 11,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#1E90FF" }
  },

  // 12
  {
    label: "Order Work Complete",
    sortorder: 12,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#eb0c61ff" }
  },

  // 13
  {
    label: "Warranty Running",
    sortorder: 13,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#7851A9" }
  },

  // 14
  {
    label: "Warranty Lost",
    sortorder: 14,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#476038ff" }
  },

  // 15
  {
    label: "AMC Running",
    sortorder: 15,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#008080" }
  },

  // 16
  {
    label: "AMC Lost",
    sortorder: 16,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#f71702ff" }
  },

  // 17
  {
    label: "AMC Direct Order",
    sortorder: 17,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#87e2deff" }
  },

  // 18
  {
    label: "One Time",
    sortorder: 18,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9b3131ff" }
  }
];
//ended by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket

export const ORDER_STATUS_VALUES = [
  //Updated by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket
  // 1
  {
    label: "Enquiry Pending",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
    css: { color: "black", backgroundColor: "#C7DCE3" }
  },

  // 2
  {
    label: "Enquiry Lost",
    sortorder: 2,
    is_converted: false,
    is_lost: true,
    css: {
      backgroundColor: "#008080", // Green Yellow
    }
  },

  // 3
  {
    label: "Site Visit Pending",
    sortorder: 3,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#8B4513" }
  },

  // 4
  {
    label: "Site Visit Complete",
    sortorder: 4,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#32CD32" }
  },

  // 5
  {
    label: "Site Visit Lost",
    sortorder: 5,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 6
  {
    label: "Offer Pending",
    sortorder: 6,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FFD700" }
  },

  // 7
  {
    label: "Offer Submitted",
    sortorder: 7,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FF9D23" }
  },

  // 8
  {
    label: "Offer Lost",
    sortorder: 8,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#7d0e04ff" }
  },

  // 9
  {
    label: "Order Received",
    sortorder: 9,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9ef49eff" }
  },

  // 10
  {
    label: "Order Lost",
    sortorder: 10,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#3833ceff" }
  },

  // 11
  {
    label: "Order Work in Progress",
    sortorder: 11,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#1E90FF" }
  },

  // 12
  {
    label: "Order Work Complete",
    sortorder: 12,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#eb0c61ff" }
  },

  // 13
  {
    label: "Warranty Running",
    sortorder: 13,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#7851A9" }
  },

  // 14
  {
    label: "Warranty Lost",
    sortorder: 14,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#476038ff" }
  },

  // 15
  {
    label: "AMC Running",
    sortorder: 15,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#008080" }
  },

  // 16
  {
    label: "AMC Lost",
    sortorder: 16,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#f71702ff" }
  },

  // 17
  {
    label: "AMC Direct Order",
    sortorder: 17,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#87e2deff" }
  },

  // 18
  {
    label: "One Time",
    sortorder: 18,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9b3131ff" }
  }
];
//ended by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket

export const WARRANTY_STATUS_VALUES = [
  //Updated by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket
  // 1
  {
    label: "Enquiry Pending",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
    css: { color: "black", backgroundColor: "#C7DCE3" }
  },

  // 2
  {
    label: "Enquiry Lost",
    sortorder: 2,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 3
  {
    label: "Site Visit Pending",
    sortorder: 3,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#8B4513" }
  },

  // 4
  {
    label: "Site Visit Complete",
    sortorder: 4,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#32CD32" }
  },

  // 5
  {
    label: "Site Visit Lost",
    sortorder: 5,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#F93827" }
  },

  // 6
  {
    label: "Offer Pending",
    sortorder: 6,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FFD700" }
  },

  // 7
  {
    label: "Offer Submitted",
    sortorder: 7,
    is_converted: false,
    is_lost: false,
    css: { backgroundColor: "#FF9D23" }
  },

  // 8
  {
    label: "Offer Lost",
    sortorder: 8,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#7d0e04ff" }
  },

  // 9
  {
    label: "Order Received",
    sortorder: 9,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9ef49eff" }
  },

  // 10
  {
    label: "Order Lost",
    sortorder: 10,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#3833ceff" }
  },

  // 11
  {
    label: "Order Work in Progress",
    sortorder: 11,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#1E90FF" }
  },

  // 12
  {
    label: "Order Work Complete",
    sortorder: 12,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#eb0c61ff" }
  },

  // 13
  {
    label: "Warranty Running",
    sortorder: 13,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#7851A9" }
  },

  // 14
  {
    label: "Warranty Lost",
    sortorder: 14,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#476038ff" }
  },

  // 15
  {
    label: "AMC Running",
    sortorder: 15,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#008080" }
  },

  // 16
  {
    label: "AMC Lost",
    sortorder: 16,
    is_converted: false,
    is_lost: true,
    css: { backgroundColor: "#f71702ff" }
  },

  // 17
  {
    label: "AMC Direct Order",
    sortorder: 17,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#87e2deff" }
  },

  // 18
  {
    label: "One Time",
    sortorder: 18,
    is_converted: true,
    is_lost: false,
    css: { backgroundColor: "#9b3131ff" }
  }
];
//ended by Imran Khan on 6-1-2026 Offer Status with Colors AMC Ticket

export const AMC_STATUS_VALUES = [
  {
    label: "Warranty",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#F76F72",
    }
  },
  {
    label: "Pending",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#c7dce3",
      color: "#000000",
    }
  },
  {
    label: "Due",
    sortorder: 3,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#FFD700", // Example yellow
    }
  },
  {
    label: "Done",
    sortorder: 4,
    is_converted: true,
    is_lost: false,
    css: {
      backgroundColor: "#D6B4FC",
    }
  },
  {
    label: "AMC Running",
    sortorder: 5,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#008080", // Red
    }
  },
  {
    label: "Not Done",
    sortorder: 6,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#CD853F",
    }
  },
  {
    label: "Lost",
    sortorder: 7,
    is_converted: false,
    is_lost: true,
    css: {
      backgroundColor: "#F93827",
    }
  },
  {
    label: "One Time",
    sortorder: 8,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#CD853F",
    }
  },
  {
    label: "Advance Order",
    sortorder: 9,
    is_converted: false,
    is_lost: false,
    css: {
      backgroundColor: "#ADD8E6", // Light blue
    }
  }
];


export const Product_CATEGORY_VALUES = [
  {
    label: "Software",
    sortorder: 1,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Hardware",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Fashion",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Retail",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Goods",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Furniture",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Stones",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Policy",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
  {
    label: "Others",
    sortorder: 2,
    is_converted: false,
    is_lost: false,
  },
];

export const Repair_CATEGORY_VALUES = [
  {
    label: "Ticket Created",
    sortorder: 1,
    backgroundColor: "#DB7093", // Pale Violet Red
  },

  {
    label: "In Discussion",
    sortorder: 2,
    backgroundColor: "#DB7093", // Pale Violet Red
  },
  {
    label: "Not Working",
    sortorder: 3,
    backgroundColor: "#66CDAA", // Medium Aquamarine
  },
  {
    label: "Advance Recived",
    sortorder: 4,
    backgroundColor: "#20B2AA", // Light Sea Green
  },
  {
    label: "Work Started",
    sortorder: 5,
    backgroundColor: "#6495ED", // Cornflower Blue
  },
  {
    label: "Work Completed",
    sortorder: 6,
    backgroundColor: "#E9967A", // Dark Salmon
  },
];

export const Project_Stage_Status = [
  {
    label: "Quote Sent",
    sortorder: 1,
    backgroundColor: "#483D8B", // Dark Slate Blue
  },
  {
    label: "Quote Rejected",
    sortorder: 2,
    backgroundColor: "#09C58A", // Saddle Brown
  },
  {
    label: "Quote Approved",
    sortorder: 3,
    backgroundColor: "#8B4513", // Saddle Brown
  },
  {
    label: "Advance Received",
    sortorder: 4,
    backgroundColor: "#2E8B57", // Sea Green
  },
  {
    label: "Transfer To Production",
    sortorder: 5,
    backgroundColor: "#FF6347", // Tomato
  },

  {
    label: "Production InProgress",
    sortorder: 6,
    backgroundColor: "#10B6D5", // Dodger Blue
  },
  {
    label: "Production Completed",
    sortorder: 7,
    backgroundColor: "#1E90FF", // Dodger Blue
  },
  {
    label: "Part Dispatched",
    sortorder: 8,
    backgroundColor: "#D43434", // Dodger Blue
  },
  {
    label: "Dispatched",
    sortorder: 9,
    backgroundColor: "#DAA520", // Goldenrod
  },
  {
    label: "Installation Started",
    sortorder: 10,
    backgroundColor: "#FF8C00", // Dark Orange
  },
  {
    label: "Installation Completed (Gets a Signed Slip)",
    sortorder: 11,
    backgroundColor: "#C71585", // Medium Violet Red
  },
  {
    label: "On-Hold",
    sortorder: 12,
    backgroundColor: "#8B008B", // Dark Magenta
  },
  {
    label: "Payment Received",
    sortorder: 13,
    backgroundColor: "#4682B4", // Steel Blue
  },
  {
    label: "Project Complete",
    sortorder: 14,
    backgroundColor: "#6A5ACD", // Slate Blue
  },

  // {
  //   label: "On-Hold",
  //   sortorder: 15,
  //   is_converted: false,
  //   is_lost: false,
  //   backgroundColor: "#BA55D3", // Peru
  // },
];

export const LIST_TAB_TITLE = {
  Home: "Fuzi Elevators",
  "ContactList": "Contact List",
  // "ContactEdit":"Contact Create",
  // "ContactCreate":"Contact Edit",
  // "ContactView":"Contact View",
  // "LeadList":"Lead List",
  // "LeadEdit":"Lead Create",
  // "LeadCreate":"Lead Edit",
  // "LeadView":"Lead View",
  // "ProductList":"Product List",
  // "ProductEdit":"Product Create",
  // "ProductCreate":"Product Edit",
  // "ProjectList":"Project List",
  // "ProjectEdit":"Project Create",
  // "ProjectCreate":"Project Edit",
  // "ProjectView":"Project View",
};

export const Project_Stage_Name = [
  {
    label: "Raw Material Purchase",
    sortorder: 1,
  },
  {
    label: "Material Finishing",
    sortorder: 2,
  },
  {
    label: "Stiching",
    sortorder: 3,
  },
  {
    label: "Order Dispatching",
    sortorder: 4,
  },
  {
    label: "Order Finishing",
    sortorder: 5,
  },

  {
    label: "Feeding and mixing",
    sortorder: 1,
  },
  {
    label: "Moulding and pressing",
    sortorder: 2,
  },
  {
    label: "Curing",
    sortorder: 3,
  },
  {
    label: "Polishing",
    sortorder: 4,
  },
  {
    label: "Quality Testing",
    sortorder: 5,
  },
  {
    label: "Tagging",
    sortorder: 6,
  },

  {
    label: "Dryer",
    sortorder: 1,
  },
  {
    label: "Pressing",
    sortorder: 2,
  },
  // {
  //     label: "A/c Room",
  //     sortorder: 3,
  // },
  {
    label: "Cutting",
    sortorder: 3,
  },
  {
    label: "Sanding",
    sortorder: 4,
  },
  {
    label: "Quality Check",
    sortorder: 5,
  },
  // {
  //     label: "BSR (Stock Ready)",
  //     sortorder: 7,
  // },
  {
    label: "Dispatch",
    sortorder: 6,
  },
];

export const SITE_VISIT_STATUS = [
  {
    label: "Pending",
    sortorder: 1,
    css: {
      color: 'black',
      backgroundColor: "#c7dce3", // Yellow
    }
  },
  {
    label: "Complete",
    sortorder: 2,
    css: {
      backgroundColor: "#008000", // Yellow
    }
  },
];

export const HEADERS = Project_Stage_Status.map((stage, index) => {
  const colors = [
    { backgroundColor: "rgba(23, 162, 184, .8)", color: "#000" }, // for "Raw Material Purchase"
    { backgroundColor: "rgba(255, 165,  1, .8)", color: "#000" }, // for "Pressing"
    { backgroundColor: "#EA7276", color: "#fff" }, // for "Cutting"
    { backgroundColor: "#B69DC5", color: "#fff" }, // for "Sanding"
    { backgroundColor: "#cfb593", color: "#fff" }, // for "Quality Check"
    { backgroundColor: "rgba(0, 137, 89, .8)", color: "#000" }, // for "Dispatch"
  ];

  return {
    sequence: index,
    headerName: stage.label,
    className: "kanban-column-title",
    backgroundColor: colors[index % colors.length].backgroundColor,
    color: colors[index % colors.length].color,
    borderColor: "rgba(23, 162, 184, .3)",
    columnClassName: "kanban-column",
    columnBox: "kanban-box",
  };
});

export function getSequnceHeaders(data) {
  if (data) {
    return (
      data &&
      data?.sort((a, b) =>
        b.sequence === null || a.sequence < b.sequence
          ? -1
          : a.sequence === null || a.sequence > b.sequence
            ? 1
            : a.sequence === b.sequence
              ? 0
              : Infinity
      )
    );
  }
}

export const ChartColors = [
  "#6096B4",
  "#93BFCF",
  "#E6C229",
  "#FF7F00",
  "#D62728",
  "#93cfa9",
  "#c893cf",
  "#9a93cf",
  "#cacf93",
  "#29e66e",
  "#a429e6",
];


export const titles = [
  { value: "Contractor", label: "Contractor" },
  { value: "Architect", label: "Architect" },
  { value: "Supplier", label: "Supplier" },
  { value: "Customer", label: "Customer" },
  { value: "Dealer", label: "Dealer" },
  // { value: "Customer Enquiry", label: "Customer Enquiry" },
];

export const sourceNames = [
  "On Call",
  "Website",
  "Call Centre",
  "Social Media",
  "BNI",
  "Old Customer",
  "Office Visit",
  "Tender"
];

export const PAYMENT_TYPES = [
  { value: "Cash", label: "Cash" },
  { value: "Cheque", label: "Cheque" },
  // { value: "UPI", label: "UPI" },
  // { value: "Card", label: "Card" },
  // { value: "Bank Transfer", label: "Bank Transfer" },
  // { value: "Net Banking", label: "Net Banking" },
  // { value: "Other", label: "Other" },
];

export const PAYMENT_FREQUENCY_VALUES = [
  {
    label: "Advance",
    value: "Advance",
    sortorder: 1,
    css: {
      color: 'black',
      backgroundColor: "#c7dce3", // Yellow
    }
  },
  {
    label: "After",
    value: "After",
    sortorder: 2,
    css: {
      backgroundColor: "#8B4513", // Spring Green
    }
  },
];

export const ROLES = [
  'SUPER_ADMIN',
  'ADMIN',
  'USER',
];

export const SystemAdmin = {
  id: "add7702d-5ee0-4f50-80c2-4a24065a6867",
  name: "SYS_ADMIN",
  role: "SUPER_ADMIN",
}

//Added by shahir hussain for segment type field 02-02-2026
export const SegmentOptions = [
  "Residential",
  "Hospital",
  "Hotel",
  "School",
  "College",
  "Commercial",
  "Office",
  "Villa",
  "Retail",
  "Infra",
  "Temple",
].map((item) => ({
  label: item,
  value: item,
}));
